import React from 'react'
import { useConfirmOrderAction } from '../hooks/useCheckoutAction'
import { BusyButton } from '@ztechapps/webui.button'
import { useCheckoutContext } from '../index'

export const ConfirmOrderButton = ({ onClick }) => {
  const [onConfirmOrder] = useConfirmOrderAction()
  const context = useCheckoutContext()

  const [showLoadingOverlay] = context.showLoadingOverlay

  return (
    <BusyButton
      onClick={() => {
        return onConfirmOrder({ onClick })
      }}
      icon="envelope"
      isBusy={showLoadingOverlay}
      busyText="Sending..."
      text="Message Us!"
    />
  )
}
